let _isStickySupported
export const isStickySupported = () => {
  if (typeof document === 'undefined') {
    return false
  }
  if (_isStickySupported === undefined) {
    const node = document.createElement('a')
    const style = node.style
    style.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;'
    _isStickySupported = style.position.indexOf('sticky') !== -1
  }
  return _isStickySupported
} 
